import React from "react";
import { Helmet } from "react-helmet-async";
import Content from "../components/Content";
/* import Gallery from "../components/Gallery"; */
import Footer from "../components/Footer/Footer";

const About = () => {
  const baseUrl = "https://tudominio.com/sammy";
  
  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>Sammy - Acerca de</title>
        <meta name="description" content="Acerca de Sammy. Conoce más sobre nosotros." />
        <link rel="canonical" href={`${baseUrl}/about`} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${baseUrl}/about`} />
        <meta property="og:title" content="Sammy - Acerca de" />
        <meta property="og:description" content="Acerca de Sammy. Conoce más sobre nosotros." />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "Sammy - Acerca de",
            "description": "Acerca de Sammy. Conoce más sobre nosotros.",
            "url": `${baseUrl}/about`,
            "mainEntity": {
              "@type": "Organization",
              "name": "Sammy",
              "url": `${baseUrl}/home`
            }
          })}
        </script>
      </Helmet>
      <Content />
      {/* <Gallery /> */}
      <Footer />
    </>
  );
};

export default About;
